var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "80px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "手机号码", prop: "cusPhone" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: {
                      type: "text",
                      maxlength: "11",
                      size: "small",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.form.cusPhone,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cusPhone", $$v)
                      },
                      expression: "form.cusPhone"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "姓名" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: {
                      type: "text",
                      maxlength: "10",
                      size: "small",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.form.cusName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cusName", $$v)
                      },
                      expression: "form.cusName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注信息" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: {
                      type: "textarea",
                      maxlength: "50",
                      size: "small",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _vm.type == "add"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.handleDefine(true)
                        }
                      }
                    },
                    [_vm._v("保存并继续创建")]
                  )
                : _vm._e(),
              _vm.type == "add"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.handleDefine(false)
                        }
                      }
                    },
                    [_vm._v("完成")]
                  )
                : _vm._e(),
              _vm.type == "edit"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.dialogVisible = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  )
                : _vm._e(),
              _vm.type == "edit"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.handleDefine(false)
                        }
                      }
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }